import { useTranslation } from "@impero-com/common/utils/i18n";
import { useLocalUserSetting } from "@impero-com/common/utils/localUserSettings";
import { Section, SectionContent, SectionHeader } from "@impero-com/ui";
import { Switch } from "antd";

import * as theme from "./NavigationSettings.css";

export function NavigationSettings() {
    const { t } = useTranslation();
    const [useOldMenu, setUseOldMenu] = useLocalUserSetting("useOldMenu");

    return (
        <Section>
            <SectionHeader
                level={4}
                titleLabel={t("MyProfile_Navigation_Title")}
                subtitleLabel={t("MyProfile_Navigation_Description")}
                showBorder
            />
            <SectionContent>
                <div className={theme.row}>
                    <Switch
                        id="use-old-menu"
                        checked={useOldMenu}
                        onChange={setUseOldMenu}
                    />
                    <label htmlFor="use-old-menu" className={theme.label}>
                        <span>
                            {t("MyProfile_Navigation_UseOldMenu_Label")}
                        </span>
                        <span className={theme.description}>
                            {t("MyProfile_Navigation_UseOldMenu_Description")}
                        </span>
                    </label>
                </div>
            </SectionContent>
        </Section>
    );
}
